import { Component, OnInit } from '@angular/core';
import { E5coreUiSearchMenuBase } from './e5core-ui-search-menu-base';

@Component({
  selector: 'e5core-ui-search-menu-box',
  templateUrl: './e5core-ui-search-menu-box.component.html',
  styleUrls: ['./e5core-ui-search-menu-box.component.css']
})
export class E5coreUiSearchMenuBoxComponent extends E5coreUiSearchMenuBase {

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
